import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import {
  NegotiationCaseCreateWizardState,
  toNegotiationCaseInputMapper,
} from '../NegotiationCaseCreateWizard/NegotiationCaseCreateWizard.schema';
import { useWizardState } from '~/components/WizardState/hooks/useWizardState/useWizardState';
import { DEMAND_CASES_QUERY } from '~/modules/DemandCasesWidget/DemandCasesQuery.gql';

import { CREATE_NEGOTIATION_CASE_MUTATION } from './CreateCase.mutation.gql';

export const useCreateCase = () => {
  const { state } = useWizardState<NegotiationCaseCreateWizardState>();
  const [createNegotiationMutation] = useMutation(CREATE_NEGOTIATION_CASE_MUTATION, {
    refetchQueries: [
      {
        query: DEMAND_CASES_QUERY,
        variables: {
          id: state.demand.id,
        },
      },
    ],
  });

  return useCallback(
    async (state: NegotiationCaseCreateWizardState) => {
      const { success, data: inputData, error } = toNegotiationCaseInputMapper.safeParse(state);

      if (success) {
        const { errors } = await createNegotiationMutation({ variables: inputData });
        return { success: !errors, error: errors };
      }
      return { success: false, error };
    },
    [createNegotiationMutation],
  );
};
